// The Code tab's own icons, drawn like the board's (components/Icons.tsx):
// 16 px boxes, strokes in the text's colour. Moved from today's Code tab
// (code/icons.tsx there), with the plus, the cross, and the two arrows of
// today's components/Icons.tsx, which only the Code tab uses here.
import type { SVGProps } from 'react'

type IconProps = SVGProps<SVGSVGElement> & { size?: number }

function Svg({ size = 16, children, ...rest }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false" {...rest}>
      {children}
    </svg>
  )
}

/** Stop the turn. */
export function StopIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="3.75" y="3.75" width="8.5" height="8.5" rx="1.6" fill="currentColor" />
    </Svg>
  )
}

/** Send the prompt. */
export function SendIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M8 13V3.5M3.75 7.5 8 3.25l4.25 4.25" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}

/** The pane on the right, as macOS draws a trailing sidebar. */
export function SidePaneIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <rect x="1.75" y="2.75" width="12.5" height="10.5" rx="2" stroke="currentColor" strokeWidth="1.4" />
      <path d="M10 3v10" stroke="currentColor" strokeWidth="1.4" />
      <path d="M11.5 5.5h1M11.5 7.5h1" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </Svg>
  )
}

/** The list of sessions, where it is a drawer. */
export function ListIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M2.75 4h10.5M2.75 8h10.5M2.75 12h10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </Svg>
  )
}

export function PlusIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M8 3v10M3 8h10" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </Svg>
  )
}

export function CloseIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="m4 4 8 8m0-8-8 8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </Svg>
  )
}

/** Maximise: two arrows that part, each to its corner. */
export function MaximiseIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9 3.25h3.75V7M12.75 3.25 9 7M7 12.75H3.25V9M3.25 12.75 7 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}

/** Minimise: the same two arrows, turned to meet in the middle. */
export function MinimiseIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <path d="M9.25 3v3.75H13M9.25 6.75 13 3M6.75 13V9.25H3M6.75 9.25 3 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  )
}

/** A question a session asks: a question mark in a ring. */
export function QuestionIcon(props: IconProps) {
  return (
    <Svg {...props}>
      <circle cx="8" cy="8" r="6.25" stroke="currentColor" strokeWidth="1.5" />
      <path d="M6.3 6.2a1.8 1.8 0 0 1 3.5.5c0 1.2-1.8 1.5-1.8 2.6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="8" cy="11.4" r="0.85" fill="currentColor" />
    </Svg>
  )
}
